module.exports = __webpack_public_path__ + "img/phonics_icon.74852ad9.png";